import VacancyFillCandidateModal from './VacancyFillCandidateModal.component';

export default VacancyFillCandidateModal;
